<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="110px"
  >
    <el-form-item label="服务器类型" prop="apiType">
      <el-radio-group v-model="form.apiType">
        <el-radio v-for="(type, index) in typeList" :label="type.key" :key="type.key">{{ type.name }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="服务器名称"
      prop="apiName"
    >
      <el-input
        placeholder="服务器名称"
        v-model="form.apiName"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="apiHost"
      label="服务器地址"
    >
      <el-input
        placeholder="服务器地址"
        v-model="form.apiHost"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="apiPort"
      label="服务器端口"
    >
      <el-input
        v-model="form.apiPort"
        placeholder="服务器端口"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="微信安装路径"
      prop="wechatFilePath"
    >
      <el-input
        v-model="form.wechatFilePath"
        placeholder="微信安装路径"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="状态"
      size="mini"
      prop="status"
    >
      <el-radio-group v-model="form.status">
        <el-radio :label="0">禁用</el-radio>
        <el-radio :label="1">正常</el-radio>
      </el-radio-group>
    </el-form-item>

  </el-form>
</template>

<script>
import {validatEmail,isMobile} from "@/utils/validate";
let origin = {
  apiType: 1,
  apiName: '',
  apiHost: '',
  apiPort: '',
  wechatFilePath: '',
  status: 1,
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "wechatServerForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {
          id: ''
        };
      }
    }
  },
  data() {
    return {
      typeList:[
        {key:1,name:'DLL'},
        {key:2,name:'Wechaty'}
      ],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        apiType: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        apiName: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        apiHost: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        apiPort: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        wechatFilePath: [
          { required:true, message: '手机不能为空', trigger: 'blur' },
        ],
        status: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
      },
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assigen(newValue);
        }
      },
      deep: true,
    }
  },
  mixins: [formLabalPosition],
  methods: {

    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(data){
      this.form.id = data.id;
      this.form.apiType = data.apiType;
      this.form.apiName = data.apiName;
      this.form.apiHost = data.apiHost;
      this.form.apiPort = data.apiPort;
      this.form.wechatFilePath =data.wechatFilePath;
      this.form.status = data.status;
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>

</style>
